module.exports = __webpack_public_path__ + "static/media/Step2.2d7cac58.JPG";